/** Corporate attribution — the twin of my.x9.app's sidebar footer. */
import HwyahLogo from './HwyahLogo';
import { cn } from '../lib/utils';

const HWYAH_SITE = 'https://hwyah.com';

export default function HwyahProductFooter({
  className,
  align = 'end',
}: {
  className?: string;
  align?: 'start' | 'end';
}) {
  const start = align === 'start';
  const logo = (
    <HwyahLogo monochrome className="h-12 w-auto shrink-0 text-foreground" title="HWYAH" />
  );
  const copy = (
    <span className={`text-[10px] leading-snug ${start ? 'text-left' : 'text-right'}`}>
      x9 is a Product of:
      <br />
      Happy When You Are Happy Ltda
      <br />
      CNPJ: 64.795.624/0001-25
    </span>
  );
  return (
    <a
      href={HWYAH_SITE}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center gap-2 text-muted-foreground transition-colors hover:text-foreground',
        start ? 'justify-start' : 'justify-end',
        className,
      )}
    >
      {start ? (
        <>
          {logo}
          {copy}
        </>
      ) : (
        <>
          {copy}
          {logo}
        </>
      )}
    </a>
  );
}
